import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute } from "@tanstack/react-router";
import ShoppableLanding from "@/pages/ShoppableLanding";

export const Route = createFileRoute("/shop/$slug")({
  beforeLoad: ({ params }) => ensureExists("shoppable_landings", params.slug),
  component: ShoppableLanding,
});
